import { generateFixedColorGradient } from '../../ui/colors';
import { IThemeContextUpdate } from '../../ui/contexts/ThemeProvider';
import { mixArrays } from '../../ui/utils';
import { IAgreement } from '../dashboard/types';

enum BookstoreType {
  BOOK,
  MAGAZINE,
  AUDIOBOOK,
  MULTIPLE,
}

export interface BookstoreLabels {
  singular: string;
  plural: string;
  prefixedSingular: string;
  prefixedPlural: string;
  prefix: string;
  prefixPlural: string;
}

function getBookstoreType(bookstoreTypes: string[]): BookstoreType {
  if (bookstoreTypes.length > 1) return BookstoreType.MULTIPLE;

  if (bookstoreTypes[0] === 'book') return BookstoreType.BOOK;

  if (bookstoreTypes[0] === 'audiobook') return BookstoreType.AUDIOBOOK;

  return BookstoreType.MAGAZINE;
}

function getBookstoreLabels(bookstoreType: BookstoreType): BookstoreLabels {
  let labels: BookstoreLabels;

  if (bookstoreType === BookstoreType.BOOK) labels = { singular: 'Livro', plural: 'Livros', prefix: 'o' };
  else if (bookstoreType === BookstoreType.MAGAZINE) labels = { singular: 'Revista', plural: 'Revistas', prefix: 'a' };
  else if (bookstoreType === BookstoreType.AUDIOBOOK) labels = { singular: 'Audio Book', plural: 'Audio Books', prefix: 'o' };
  else labels = { singular: 'Mídia', plural: 'Mídias', prefix: 'a' };

  labels.prefixPlural = labels.prefix + 's';
  labels.prefixedPlural = labels.prefixPlural + ' ' + labels.plural;
  labels.prefixedSingular = labels.prefix + ' ' + labels.singular;

  return labels;
}

export function parseAgreementToTheme(agreement: IAgreement): IThemeContextUpdate {
  const bookstoreType = getBookstoreType(agreement.bookstoreTypes);
  const bookstoreLabels = getBookstoreLabels(bookstoreType);
  return {
    id: agreement.id,
    name: agreement.name,
    logo: agreement.logo,
    slug: agreement.slug,
    colors: {
      primaryColor: agreement.primaryColor,
      secondaryColor: agreement.secondaryColor,
      menuColor: agreement.menuColor,
      menuFontColor: agreement.menuFontColor,
      primaryFontColor: agreement.primaryFontColor,
      secondaryFontColor: agreement.secondaryFontColor,
      graphColors: mixArrays(
        generateFixedColorGradient(agreement.primaryColor, 30),
        generateFixedColorGradient(agreement.secondaryColor, 20)
      ),
    },
    uraModuleCellphone: agreement.uraModuleCellphone,
    showBestSellers: agreement.showBestSellers,
    bookstoreTypes: agreement.bookstoreTypes,
    banners: agreement.banners,
    recurringBook: true,
    email: agreement.email,
    telephone: agreement.telephone,
    integratedLogin: agreement.integratedLogin,
    allowSignup: agreement.allowSignup,
    cpfModule: agreement.cpfModule,
    idp: agreement.idp,
    allowCpfLoginMethod: agreement.allowCpfLoginMethod,
    allowPromocodeLoginMethod: agreement.allowPromocodeLoginMethod,
    bookstoreLabels: bookstoreLabels,
  };
}

export function parseAgreementToThemeDash(agreement: IAgreement): IThemeContextUpdate {
  return {
    colors: {
      primaryColor: agreement.primaryColor,
      primaryFontColor: agreement.primaryFontColor,
      menuColor: agreement.menuColor,
      menuFontColor: agreement.menuFontColor,
      secondaryColor: agreement.secondaryColor,
      secondaryFontColor: agreement.secondaryFontColor,
      graphColors: mixArrays(
        generateFixedColorGradient(agreement.primaryColor, 30),
        generateFixedColorGradient(agreement.secondaryColor, 20)
      ),
    },
    extraData: { ...agreement },
    id: agreement.id,
    name: agreement.name,
    logo: agreement.logo,
    email: agreement.email,
    telephone: agreement.telephone,
    isLoading: false,
    banners: agreement.banners,
  };
}
